const CreditCardChargesList = [
  { desc: "Do Something Fun", category: "Entertainment & Recreation" },
  { desc: "Feed the World Charity", category: "Charities" },
  { desc: "Save the Earth Charity", category: "Charities" },
  { desc: "Save the Animals Charity", category: "Charities" },

  { desc: "Buy 1 New Tire", category: "Transportation" },
  { desc: "Full Service Oil Change", category: "Transportation" },
  { desc: "Car Repair - mid", category: "Transportation" },
  { desc: "Car Repair - minor", category: "Transportation" },
  { desc: "Automobile Body Work", category: "Transportation" },
  { desc: "Traffic Stop - Speeding Ticket", category: "Fees, Fines & Penalties" },
  { desc: "Purchase New Tires for Car", category: "Transportation" },
  { desc: "Car Maintenance", category: "Transportation" },
  { desc: "Traffic Ticket for Speeding", category: "Fees, Fines & Penalties" },
  { desc: "Towing and Car Maintenance", category: "Transportation" },
  { desc: "New Wiper Blades", category: "Transportation" },
  { desc: "Traffic Ticket", category: "Fees, Fines & Penalties" },

  { desc: "Go to a Movie and Dinner", category: "Entertainment & Recreation" },
  { desc: "Play Frisbee and Dinner", category: "Entertainment & Recreation" },
  { desc: "Camping Trip", category: "Entertainment & Recreation" },
  { desc: "Grand Canyon", category: "Entertainment & Recreation" },
  { desc: "Play Golf and Dinner", category: "Entertainment & Recreation" },
  { desc: "Go Out to Dinner With Friend", category: "Entertainment & Recreation" },
  { desc: "Local Ice Cream Shop", category: "Entertainment & Recreation" },
  { desc: "Karaoke Palace", category: "Entertainment & Recreation" },
  { desc: "Purchase a new TV", category: "Entertainment & Recreation" },
  { desc: "St. Patrick's Day celebration", category: "Entertainment & Recreation" },

  { desc: "Had to get Stitches", category: "Health & Medical" },
  { desc: "Medical Expenses", category: "Health & Medical" },
  { desc: "Injured at Work", category: "Health & Medical" },
  { desc: "Gym Membership", category: "Health & Medical" },

  { desc: "Refrigerator Repair", category: "Housing & Utilities" },
  { desc: "Apartment Water Damage", category: "Housing & Utilities" },
  { desc: "Rent due to Roommate Change", category: "Housing & Utilities" },
  { desc: "New Furniture", category: "Home Furnishings & Decor" },
  { desc: "Repair Furniture", category: "Home Furnishings & Decor" },
  { desc: "Buy New Mattress", category: "Home Furnishings & Decor" },
  { desc: "Dining Room Furniture", category: "Home Furnishings & Decor" },
  { desc: "Bedroom Furniture", category: "Home Furnishings & Decor" },
  { desc: "Reclining Chairs", category: "Home Furnishings & Decor" },
  { desc: "Remove Clog in Drain", category: "Housing & Utilities" },
  { desc: "Washing Machine Repair", category: "Housing & Utilities" },
  { desc: "New Washing Machine", category: "Housing & Utilities" },
  { desc: "Buy Pictures and Paintings", category: "Home Furnishings & Decor" },
  { desc: "Replace Broken Pitcher", category: "Home Furnishings & Decor" },
  { desc: "Buy New Sofa for Living Room", category: "Home Furnishings & Decor" },

  { desc: "Buy Food - Refrigerator Not Working", category: "Food & Groceries" },

  { desc: "Medical Bills for Friend", category: "Gifts, Donations & Support" },
  { desc: "Time Away From Work", category: "Gifts, Donations & Support" },

  { desc: "Taking the Bus", category: "Transportation" },

  { desc: "Purchase Items for a Customer", category: "Work-Related Expenses" },
  { desc: "Reimburse Cash Drawer at Work", category: "Work-Related Expenses" },
  { desc: "Cleaning Bill for Customer", category: "Work-Related Expenses" },
  { desc: "Supplies for Classroom", category: "Work-Related Expenses" },

  { desc: "Water Skis and Tow Rope", category: "Entertainment & Recreation" },
  { desc: "Inflatable Raft", category: "Entertainment & Recreation" },
  { desc: "Speed Boat Repair", category: "Entertainment & Recreation" },
  { desc: "Fix Storm Damage to Boat", category: "Entertainment & Recreation" },
  { desc: "Gas For Boat", category: "Entertainment & Recreation" },
  { desc: "Fishing Gear", category: "Entertainment & Recreation" },
  { desc: "Boat Engine Repair", category: "Entertainment & Recreation" },

  { desc: "Dog Veterinary Bill", category: "Pets & Animal Care" },
  { desc: "Veterinary Bill for Cat", category: "Pets & Animal Care" },
  { desc: "Veterinarian Bill (Annual Visit)", category: "Pets & Animal Care" },
  { desc: "Vet Bill for Dog", category: "Pets & Animal Care" },
  { desc: "Replace Shoes Eaten by Dog", category: "Pets & Animal Care" },
  { desc: "Clean Carpet due to Dog Mess", category: "Pets & Animal Care" },
  { desc: "Cat Toys", category: "Pets & Animal Care" },
  { desc: "Veterinarian Bill for Horse", category: "Pets & Animal Care" }
];

export default CreditCardChargesList;
